!function(){function e(){subSliderInit(!0),sliderInit(!0),popupSliderInit(!0)}function i(e,t){var o=e.clientHeight;e.style.transitionProperty="height, margin, padding",e.style.transitionDuration=t+"ms",e.style.boxSizing="border-box",e.style.overflow="hidden",e.style.height=o+"px",e.style.paddingTop="0",e.style.paddingBottom="0",e.style.marginTop="0",e.style.marginBottom="0",setTimeout(function(){e.style.height="0",e.style.paddingTop="0",e.style.paddingBottom="0",e.style.marginTop="0",e.style.marginBottom="0"},10),setTimeout(function(){e.style.display="none",e.style.removeProperty("height"),e.style.removeProperty("padding-top"),e.style.removeProperty("padding-bottom"),e.style.removeProperty("margin-top"),e.style.removeProperty("margin-bottom"),e.style.removeProperty("overflow"),e.style.removeProperty("transition-duration"),e.style.removeProperty("transition-property")},t)}const t=()=>{document.querySelectorAll(".about__accordion-toggle").forEach(r=>{r.addEventListener("click",()=>{if(document.querySelectorAll(".product__info-container .about__accordion-toggle").forEach(e=>{e!=r&&e.classList.remove("active")}),document.querySelectorAll(".product__info-container .about__accordion-toggle").forEach(e=>{e!=r&&i(e.nextElementSibling,300)}),r.classList.contains("active"))r.classList.remove("active"),i(r.nextElementSibling,300);else{r.classList.add("active");{var e=r.nextElementSibling,t=300;e.style.overflow="hidden",e.style.height="0",e.style.display="block";const o=e.scrollHeight;setTimeout(function(){e.style.height=o+"px"},10),setTimeout(function(){e.style.removeProperty("overflow"),e.style.removeProperty("height")},t)}}})})},o=()=>{const e=document.querySelector(".main-product .product-form__submit-wrapper");if(e){let t=!0,o=!1;const i=()=>{t||o?(e.closest(".product-form__buttons-row").removeAttribute("style"),e.classList.remove("fixed")):e.classList.contains("fixed")||(e.closest(".product-form__buttons-row").style.minHeight=e.clientHeight+"px",e.classList.add("fixed"))};new IntersectionObserver(e=>{var[e]=e;t=e.isIntersecting,i(),console.log("from buttonObserver",t,o)},{root:null,rootMargin:"0px 0px 45px 0px",threshold:.01}).observe(document.querySelector(".product-form__buttons"));var r=new IntersectionObserver(e=>{var[e]=e;o=e.isIntersecting,i(),console.log("from footerObserver",t,o)},{root:null,rootMargin:"0px",threshold:.01});document.querySelector(".footer")&&r.observe(document.querySelector(".footer"))}};class r extends ModalDialog{constructor(){super()}hide(){super.hide(),window.pauseAllMedia()}show(e){super.show(e),this.showActiveMedia()}showActiveMedia(){var e=this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);"DEFERRED-MEDIA"==e.nodeName&&e.querySelector("template")?.content?.querySelector(".js-youtube")&&e.loadContent()}}customElements.define("product-modal",r),document.addEventListener("shopify:section:load",function(){t(),o(),e()}),e(),t(),o()}();

/* ==========================================================================
   Custom: show product media thumbnails on mobile
   - The thumbnail strip (.product__media-sublist-outer) is hidden by CSS
     below 576px in section-main-product.css. This re-shows it as a
     horizontal strip under the main image and flips the thumbs Swiper
     from vertical to horizontal on small screens.
   - Safe to remove: delete everything below this comment block.
   ========================================================================== */
(function () {
  var BREAKPOINT = 576;
  var STYLE_ID = "custom-mobile-thumbs";

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent =
      "@media screen and (max-width: 575px){" +
      ".product__media-sublist-outer{display:block;order:2;flex:0 0 auto;width:100%;max-width:100%;margin-top:.8rem;padding:0 2rem;box-sizing:border-box}" +
      ".product__outer--slider-previews .product__media-sublist,.product__media-sublist{max-width:100%;height:auto;margin-inline:0}" +
      ".product__media-sublist .swiper-wrapper{flex-direction:row;height:auto}" +
      ".product__media-sublist:not(.swiper-initialized){flex-direction:row;gap:.4rem;overflow-x:auto}" +
      ".product__media-sublist .product__media-subitem{flex:0 0 auto;width:6.4rem;height:auto}" +
      ".product__media-sublist .product__media-subitem .product__media img{border-radius:var(--border-radius-main)}" +
      "}";
    document.head.appendChild(style);
  }

  function isMobile() {
    return window.innerWidth < BREAKPOINT;
  }

  function mainSwiperFor(sublist) {
    var scope = sublist.closest(".product__outer") || document;
    var list = scope.querySelector(".product__media-list");
    return list && list.swiper ? list.swiper : null;
  }

  function syncDirection() {
    var wanted = isMobile() ? "horizontal" : "vertical";
    document.querySelectorAll(".js-media-sublist").forEach(function (sublist) {
      var sw = sublist.swiper;
      if (!sw || sw.destroyed) return;
      try {
        if (sw.params.direction !== wanted) sw.changeDirection(wanted, true);
        sw.update();
      } catch (err) {
        /* swiper not ready yet - next pass will pick it up */
      }
    });
  }

  function bindClicks() {
    document.querySelectorAll(".js-media-sublist").forEach(function (sublist) {
      if (sublist.dataset.mobileThumbsBound === "true") return;
      sublist.dataset.mobileThumbsBound = "true";
      sublist.addEventListener("click", function (event) {
        if (!isMobile()) return;
        var item = event.target.closest(".product__media-subitem");
        if (!item) return;
        var items = Array.prototype.slice.call(
          sublist.querySelectorAll(".product__media-subitem")
        );
        var index = items.indexOf(item);
        var main = mainSwiperFor(sublist);
        if (index < 0 || !main) return;
        main.slideTo(index);
        items.forEach(function (el) {
          el.classList.remove("swiper-slide-thumb-active");
        });
        item.classList.add("swiper-slide-thumb-active");
      });
    });
  }

  function run() {
    injectStyle();
    bindClicks();
    syncDirection();
    setTimeout(syncDirection, 600);
  }

  function debounced(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  window.addEventListener("resize", debounced(run, 200));
  document.addEventListener("shopify:section:load", function () {
    setTimeout(run, 300);
  });
})();
